export const ACCOUNT_ROLES = {
    ACCOUNT_OWNER: 'account_owner',
    ACCOUNT_ADMIN: 'account_admin',
    ACCOUNT_MANAGER: 'account_manager',
  };
  
  export const ACCOUNT_ROLES_LABELS = {
    [ACCOUNT_ROLES.ACCOUNT_OWNER]: 'Account Owner',
    [ACCOUNT_ROLES.ACCOUNT_ADMIN]: 'Account Admin',
    [ACCOUNT_ROLES.ACCOUNT_MANAGER]: 'Account Manager',
  };
  